export const styles = theme => ({
  screen: {
    background: theme.palette.background.paper,
    display: "flex",
    flexDirection: "row",
    height: "100vh",
    justifyContent: "center",
    alignContent: "center"
  },
  card: {
    display: "flex",
    flexDirection: "column",
    // boxShadow: "2px 2px 2px 1px #ccc",
    // background: theme.palette.background.secondary
    background: "white",
    height: "100vh",
    borderRadius: 0
  },
  header: {
    // height: "1rem",
    justifyContent: "center",
    textAlign: "center",
    flexDirection: "row",
    alignItems: "center",
    color: "white",
    padding: "2rem",
    background: theme.palette.primary.main,
    fontFamily: "Montserrat, sans-serif"
  },
  content: {
    background: "#FFFFFF",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    fontFamily: "Montserrat, sans-serif"
  },
  top: {
    display: "flex",
    flexDirection: "row",
    height: "100%",
    flex: 0.1,
    justifyContent: "center"
  },
  dotContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    margin: "1rem 0 1rem 0"
  },
  dot: {
    borderRadius: "100%",
    width: "10px",
    height: "10px",
    margin: "0.5rem"
  },
  middle: {
    display: "flex",
    flexDirection: "column",
    flex: 0.8,
    alignItems: "center"
  },
  icon: {
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
    margin: "1rem 0 1rem 0"
  },
  inputField: {
    display: "flex"
  },
  mapLabel: {
    textAlign: "center",
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 600,
    marginTop: "5px",
    fontSize: "0.9rem",
    color: theme.palette.primary.dark,
    background: "whitesmoke",
    padding: 5,
    borderRadius: "5px 5px 5px 5px",
    boxShadow: "1px 1px 1px 1px #ccc"
  },
  times: {
    lineHeight: "10px",
    textAlign: "center",
    fontWeight: 600,
    fontSize: "0.7rem"
  },
  bottom: {
    display: "flex",
    flex: 0.5,
    flexDirection: "column"
  },
  button: {
    display: "flex",
    flexDirection: "row",
    minWidth: "225px",
    width: "80%",
    alignSelf: "center",
    justifySelf: "center",
    margin: "20px",
    [theme.breakpoints.down(365)]: {
      margin: 10
    }
  },
  changeZipButton: {
    position: "fixed",
    bottom: 40,
    left: 30,
    [theme.breakpoints.down(365)]: {
      left: 20
    },
    [theme.breakpoints.up(450)]: {
      left: 60
    }
  },
  closestHotspotButton: {
    position: "fixed",
    bottom: 40,
    right: 30,
    [theme.breakpoints.down(365)]: {
      right: 20
    },
    [theme.breakpoints.up(450)]: {
      right: 60
    }
  },
  list: {
    height: "100%",
    width: "80vw",
    overflow: "auto"
  },
  userLocationListItem: {
    paddingLeft: 0
  }
});
